<script>

export default {
  name: "Recruit",
  data() {
    return {
      positions: [
        {
          sort: '01',
          image: require('../assets/img/career/01.jpg'),
          title: '研究開発',
          descriptions: ['自動車業界から化学メーカーへ。', 'ノウハウをクレハで遺憾無く発揮。'],
          tags: '#CAE解析  #PGA樹脂  #後輩育成',
          to: '/midcareer/staff01'
        },
        // {
        //   sort: '02',
        //   image: require('../assets/img/career/02.jpg'),
        //   title: '情報システム',
        //   descriptions: ['システム刷新プロジェクトへの挑戦。', '正解のない中で最適解を導き出す。'],
        //   tags: '#ネットワークエンジニア  #システム導入 \n#正解がない仕事',
        //   to: '/midcareer/staff02'
        // },
        {
          sort: '02',
          image: require('../assets/img/career/03.jpg'),
          title: '法　務',
          descriptions: ['法律の専門性を磨きながら、', '事業の基盤を作り上げていく。'],
          tags: '#社会への貢献  #企業法務  #他部署との協働',
          to: '/midcareer/staff02'
        },
        {
          sort: '03',
          image: require('../assets/img/career/04.jpg'),
          title: '設備保全',
          descriptions: ['電気設備の施工経験を活かして、', '事業所のスマート保全化に挑む。'],
          tags: '#電気設備  #生産環境の質向上 \n#スマート保全化',
          to: '/midcareer/staff03'
        }
      ],
      heroBannerImages: [
        [
          require('@/assets/img/career/hero-01.jpg'),
          require('@/assets/img/career/hero-02.jpg'),
          require('@/assets/img/career/hero-03.jpg'),
          require('@/assets/img/career/hero-04.jpg')
        ],
        [
          require('@/assets/img/career/hero-05.jpg'),
          require('@/assets/img/career/hero-06.jpg'),
          {
            desktop: require('@/assets/img/career/hero-07.jpg'),
            mobile: require('@/assets/img/career/hero-05.jpg')
          },
          require('@/assets/img/career/hero-08.jpg')
        ]
      ],
      isMobile: (typeof window !== 'undefined') ? window.matchMedia('(max-width: 490px)').matches : false
    }
  },
  mounted() {
    const images = document.querySelectorAll('.hero-banner-images img')
    const background = document.querySelector('.hero-banner-bg')
    const title  = document.querySelector('.hero-banner-title')
    const texture = document.querySelector('.hero-banner-texture')
    const paragraph = document.querySelectorAll('.message > span')
    const section = document.getElementById('employee')



    this.handleImagesBanner()
    const mql = window.matchMedia('(max-width: 490px)')
    this.isMobile = mql.matches
    if (mql.addEventListener) {
      mql.addEventListener('change', (e) => { this.isMobile = e.matches })
    } else if (mql.addListener) {
      mql.addListener((e) => { this.isMobile = e.matches })
    }
    window.addEventListener('resize', () => {
      this.handleImagesBanner()
    })

    if(this.$route.hash.replace('#', '') ===  'employee'){
     setTimeout(() => {
       window.scrollTo({
         top: section.offsetTop,
         behavior: 'smooth'
       })

     }, 100)
    }



    const orderActiveAnimated = [
        [images[6], images[4], images[0]],
        [images[1], images[7], images[3]], [images[5], images[2]]
    ]

    orderActiveAnimated.forEach((images, indexImage) => {
      images.forEach((image, index) => {
        setTimeout(() => {
          image.animate([
            { opacity: 0 },
            { opacity: 1 }
          ], { easing: 'ease-in-out', duration: 800 , fill: 'forwards'})
        }, 150 * (index + 1) * (indexImage + 1))
      })
    })

    setTimeout(() => {
      background.animate([
        { opacity: 0 },
        { opacity: 0.6 }
      ], { easing: 'ease-in-out', duration: 1200, fill: 'forwards' })
    }, 800)

    setTimeout(() => {
      title.animate([
        { filter: 'blur(100px)', opacity: 1 },
        { filter: 'blur(0)', opacity: 1}
      ], { easing: 'ease-in-out', duration: 1200, fill: 'forwards' })

      texture.animate([
        { filter: 'blur(100px)' , opacity: 1, },
        { filter: 'blur(0)' , opacity: 1}
      ], { easing: 'ease-in-out', duration: 1200, fill: 'forwards' })
    }, 1000)

    setTimeout(() => {
      paragraph.forEach((p, index) => {
        setTimeout(() => {
          p.animate([
            { opacity: 0, transform: "translateY(50%)", filter: "blur(5px)" },
            { opacity: 1, transform: "translateY(0)", filter: "blur(0px)" }
          ], { easing: 'ease-in-out', duration: 500, fill: "forwards"})
        }, 200 * (index + 1))
      })
    }, 1200)
  },
  methods:{
    resolveHeroSrc(image){
      if (typeof image === 'object' && image !== null) {
        return this.isMobile ? image.mobile : image.desktop
      }
      return image
    },
    handleImagesBanner(){
      const images = document.querySelectorAll('.hero-banner-images img')
        images.forEach((image) => {
          if(window.innerWidth <= 768 && window.innerWidth >= 491){
            image.style.minWidth = '33%'
          }

          if(window.innerWidth < 1366 && window.innerWidth > 768) {
            image.style.minWidth = image.clientWidth / 2 + 'px'
          }

          if(window.innerWidth < 491){
            image.style.minWidth = '50%'
          }

        })
    }
  }
}
</script>

<template>
<div class="container">
  <div >
    <div class="hero-banner">
      <div class="hero-banner-images">
        <div v-for="(images, index) in heroBannerImages" :key="index">
          <img v-for="(image, indexImage) in images" :key="indexImage" :src="resolveHeroSrc(image)" alt="キャリア採用" />
        </div>
      </div>
      <div>
        <div class="hero-banner-bg"></div>
        <h5 class="hero-banner-title">キャリア採用</h5>
        <img class="hero-banner-texture" src="@/assets/img/career/icon-arrow-right-white.svg"  alt="キャリア採用"/>
      </div>
    </div>
    <p class="message">
      <span>クレハの真髄は「ナケレバ、ツクレバ。」の精神。</span>
      <span>まだ世の中にない価値を自分たちで作り出す。</span>
      <span>そのために必要なのが、多彩な人財です。</span>
      <span>さまざまな専門性や多様な個性の化学反応が、</span>
      <span>常識にとらわれない挑戦を可能にします。</span>
      <span>クレハとともに新たな価値を創造しませんか？</span>
    </p>

    <div class="message-human-resources" data-aos="fade-up">
      <div>
        <div class="message-human-resources__heading">
          <h5>人事部門からのメッセージ</h5>
          <span>
            <svg width="293" height="13" viewBox="0 0 293 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.635742 0.469727L3.40479 2.97571H286.216L279.146 12.1138H283.266L292.27 0.46875L0.635742 0.469727Z" fill="#3EA6C6"/>
          </svg>
          </span>
        </div>
        <div class="message-human-resources__paragraph">
          <p>　キャリア採用者の方に期待していることは、外部の視点で見て当社の「ここはおかしい」と思うところをどんどん指摘・発信し、組織や業務の進め方の変革をリードしていただくことです。当社の良いところは残しつつ、足りないところや遅れているところを皆さんの力で強化しながら、さらに企業として進化していきたいと考えています。<br class="mb-only" />新たな挑戦を、ぜひクレハでスタートしてください！</p>
          <p>　また、入社したキャリア採用者の方がスムーズに当社になじんで活躍できるよう、「キャリア採用者交流会」や「事業所見学会」など、さまざまな企画を行っています。当社への全体理解を深め、人脈ネットワークを構築していただき、長く当社でご活躍いただきたいと思います。一緒に働けることを楽しみにしています！</p>
        </div>
        <p class="message-human-resources__signature">採用担当者一同</p>
      </div>
    </div>
    <div class="container-inner" id="employee">
      <h4>社員紹介</h4>
      <div class="content-list">
        <router-link  v-for="(item, index) in positions" :key="index" :to="item.to" :class="{'is-reverse': index % 2 !== 0}" data-aos="fade-up">
          <picture >
            <source :srcset="item.image"
                    media="(min-width: 901px)">
            <source :srcset="item.image"
                    media="(max-width: 900px)">
            <img :src="item.image" alt="" />
          </picture>
          <div>
            <div>
              <span>
                {{item.sort}}
              </span>
              <span>{{item.title}}</span>
            </div>
            <p v-for="(des, indexDes) in item.descriptions" :key="indexDes">{{des}}</p>
            <p class="tag">{{item.tags}}</p>
          </div>
        </router-link>
      </div>
      <div class="action">
      <router-link to="/career/info/">
       採用情報はこちら
        <img src="@/assets/img/career/icon-arrow-right.svg" alt="採用情報はこちら" />
      </router-link>
      </div>
    </div>

  </div>
</div>
</template>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');


.container{
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,0.4976584383753502) 0%, rgba(62,165,197,0.08) 90%);
}


.container-inner{
  max-width: 1000px;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  @media print, screen and (max-width: 1024px) {
    max-width: 100%;
    //padding: 0 24px;
  }
  & > h4 {
    font-size: 36px;
    font-weight: 700;
    color: #3C3C3C;
    text-align: center;
    margin-top: 0;
    transition: font-size ease-in-out 0.3s;
    @media print, screen and (max-width: 1024px) {
      font-size: 24px;
      margin-bottom: 110px;
    }
  }

  & > .action{
    & > a{
      @media print, screen and (max-width: 1024px) {
        column-gap: 28px;
        height: 68px;
        max-width: 80%;
        font-size: 20px;
        margin-top: 126px;
        margin-bottom: 124px;
        & > img {
          width: 62px;
          object-fit: cover;
        }
      }
      background: var(--darkBlue);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 98px;
      width: 100%;
      max-width: 550px;
      column-gap: 30px;
      font-size: 25px;
      font-weight: 700;
      color: white;
      border-radius: 100px;
      margin: 156px auto 140px auto;
      transition: all ease-in-out 0.3s;
      & > img{
        transition: all ease-in-out 0.3s;
        margin-bottom: -12px;
      }
    }
  }
}

.hero-banner{
  height: 500px;
  position: relative;
  overflow: hidden;
  display:flex;
  align-items: center;
  justify-content: center;
  @media print, screen and (max-width: 1024px) {
    height: 312px;
  }
  & > div{
width: 100%;
    &:first-child{
      height: 100%;
      & > div{
        width: 100%;
        height: 50%;
        display: flex;
        align-items: center;
        & > img{
          transition: all 1s ease-in-out;
          width: 100%;
          object-fit: cover;
          height: 100%;
          opacity: 0;
        }
      }
    }
    &:last-child{
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      & > div{
        position: absolute;
        inset: 0;
        background: linear-gradient(100.22deg, #FFFFFF -6.9%, #3EA5C5 52.69%);
        transition: all ease-in-out 1s;
        opacity: 0;
      }
      & > h5{
        color: white;
        font-size: 42px;
        font-weight: 700;
        margin: 0;
        z-index: 10;
        opacity: 0;

        @media print, screen and (max-width: 1024px) {
          font-size: 28px;
        }
      }

      & > img{
        z-index: 10;
        opacity: 0;
        @media print, screen and (max-width: 1024px) {
          width: 200px;
        }
      }
    }
  }
}

.message{
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: var(--darkBlue);
  margin: 90px auto 110px auto;
  transition: font-size linear .3s;
  @media print, screen and (max-width: 1024px) {
    font-size: 16px;
    margin-top: 72px;
  }
  & > span{
    transition: all .5s ease-in-out;
    display: block;
    margin: 10px 0;
    opacity: 0;
  }
}

.content-list{
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 115px;

  @media print, screen and (max-width: 1024px) {
    row-gap: 108px;
    //padding: 0 24px;
    width: 90%;
    margin: 0 auto;
    grid-template-columns: 100%;
  }

  & > a {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    @media print, screen and (max-width: 1024px) {
      flex-direction: column;
    }
    & > picture{
      aspect-ratio: 600/340;
      width: 60%;
      max-width: 600px;
      min-width: 600px;
      border-radius: 6px;
      overflow: hidden;
      transition: all ease-in-out 0.3s;
      @media print, screen and (max-width: 1024px) {
        min-width: 95%;
        max-width: 95%;
        aspect-ratio: 375/212;
      }
      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    & > div{
      min-width: calc(100% - 600px);
      padding: 0 30px;
      box-sizing: border-box;
      transition: all ease-in-out 0.3s;
      @media print, screen and (max-width: 1024px) {
        max-width: 100%;
        width: 100%;
        padding: 0;

        & > div{
          column-gap: 24px;
          position: absolute;
          top: -54px;
        }
      }
      & > div {
        line-height: normal;
        display: flex ;
        align-items: center;
        justify-content: flex-start;
        column-gap: 28px;
        @media print, screen and (max-width: 1024px) {
          column-gap: 10px;
        }
        & > span{
          &:first-child{
            color: var(--darkBlue);
            font-size: 84px;
            font-family: 'Montserrat', sans-serif;
            font-weight: 500;
            letter-spacing: 5px;
            @media print, screen and (max-width: 1024px) {
              font-size: 64px;
            }
          }

          &:last-child{
            height: 36px;
            min-width: 164px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 18px;
            font-weight: 700;
            background-color: var(--darkBlue);
            @media print, screen and (max-width: 1024px) {
              font-size: 14px;
              height: 28px;
              min-width: 124px;
            }
          }
        }
      }
      & > p{
        margin: 0;
        transition: all ease-in-out 0.3s;
        @media print, screen and (max-width: 1024px) {
          transform: translateY(-50%);
        }
        &:not(:is(.tag)){
          background-color: white;
          color: black;
          font-size: 26px;
          padding: 0 8px;
          font-weight: 700;
          white-space: nowrap;
          line-height: normal;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 3rem;
          margin-left: -15%;
          max-width: fit-content;
          @media print, screen and (max-width: 1024px) {
           font-size: 20px;
            margin: 0;
            height: 40px;
          }
          &:nth-child(2){
            margin-bottom: 12px;
            @media print, screen and (max-width: 1024px) {
              margin-bottom: 8px;
            }
          }
        }
        &:is(.tag){
          font-size: 16px;
          font-weight: 700;
          color:var(--darkBlue);
          margin-top: 20px;
          @media print, screen and (max-width: 1024px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
    }

    @media print, screen and (min-width: 1025px) {
      &:is(.is-reverse){
        flex-direction: row-reverse;
        justify-content: flex-end;
        & > picture{
          transform: translateX(-15%);
        }
        & > div {
          padding: 0;
          z-index: 10;
          & > div{
            width: 80%;
            justify-content: center;
          }
          & > p{
            margin: 0;

            &:is(.tag){
              margin-top: 20px;
              white-space: pre-line;
              line-height: normal;
              width: 80%;
              display: flex;
              justify-content: flex-start;
              padding: 0 50px;
            }
          }
        }
      }
    }
  }
}

.hero-banner-images{
  @media print, screen and (max-width: 490px) {
    transform: translateX(-50%);
    //& > div{
    //  &:first-child{
    //    & > img {
    //      &:nth-child(3){
    //        transform: translateX(-35%);
    //        z-index: -1;
    //      }
    //    }
    //  }
    //}
  }
  //@media print, screen and (max-width: 430px) {
  //  transform: translateX(-50%);
  //}
  //@media print, screen and (max-width: 414px) {
  //  transform: translateX(-56%);
  //}
  //
  //@media print, screen and (max-width: 375px) {
  //  transform: translateX(-64%);
  //}
}

.message-human-resources{
  margin: 0 auto 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  & > div{
    background: white;
    border-radius: 20px;
    padding: 76px 88px 52px;
    max-width: 800px;
    box-sizing: border-box;
    box-shadow: 5px 5px 20px -10px var(--darkBlue);
    @media print, screen and (max-width: 1024px) {
      padding: 62px 32px 44px;
      border-radius: 12px;
    }
  }

  &__heading{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    & > h5 {
      font-size: 22px;
      font-weight: 700;
      color: #3C3C3C;
      line-height: normal;
      margin: 0;
      @media print, screen and (max-width: 1024px) {
        font-size: 18px;
      }
    }

    & > span {

      margin-top: -8px ;
      height: 12px;
      display: block;
      & > svg {
        height: 100%;
      }

      @media print, screen and (max-width: 1024px) {
        width: 238px;
        & > svg{
          width: 100%;
        }
      }
    }
  }

  &__paragraph{
    margin-top: 50px;
    @media print, screen and (max-width: 1024px) {
      margin-top: 40px;
    }
    & > p{
      margin: 0;
      font-weight: 700;
      font-size: 16px;
      line-height: 36px;
      @media print, screen and (max-width: 1024px) {
        font-size: 15px;
        line-height: 200%;

        &:first-child{
          margin-bottom: 42px;
        }
      }
    }
  }

  &__signature{
    text-align: right;
    color: #3C3C3C;
    font-size: 16px;
    line-height: 25px;
    font-weight: 700;
    @media print, screen and (max-width: 1024px) {
      font-size: 15px;
      line-height: 24px;
    }
  }
}

@keyframes translateYBlur {
  from{
    transform: translateY(5%);
    filter: blur(5px);
  }
  to{
    transform: translateY(0);
  }
}

.mb-only{
  // display: none;
  // @media print, screen and (max-width: 456px) {
  //   display: block;
  // }
}
</style>
